import {Action} from '@ngrx/store';
import * as _ from 'lodash';
import {PlayerConfigurationDefinition} from '../models/player-config-list-option';
import {
  IsUsedPlayerConfigurationDefinitionAction,
  LoadPlayerConfigurationDefinitionSuccessAction,
  playerConfigurationDefinitionActionTypes
} from '../actions/player-configuration-definition';

export interface PlayerConfigurationDefinitionState {
  array: PlayerConfigurationDefinition[];
}

const initialState: PlayerConfigurationDefinitionState = {
  array: []
};

export function playerConfigurationDefinitionReducer(state: PlayerConfigurationDefinitionState = initialState,
                                                     action: Action): PlayerConfigurationDefinitionState {
  switch (action.type) {
    case playerConfigurationDefinitionActionTypes.LOAD_SUCCESS:
      return handleLoadSuccessAction(state, action);
    case playerConfigurationDefinitionActionTypes.LOAD_FAIL:
      return handleLoadFailAction(state);
    case playerConfigurationDefinitionActionTypes.IS_USED:
      return handleIsUsedAction(state, action);
    case playerConfigurationDefinitionActionTypes.CLEAR:
      return handleClearAction(state);
    default:
      return state;
  }
}

function handleLoadSuccessAction(state: PlayerConfigurationDefinitionState,
                                 action: LoadPlayerConfigurationDefinitionSuccessAction): PlayerConfigurationDefinitionState {
  const newState = _.clone(state);
  newState.array = action.payload;
  return newState;
}

function handleLoadFailAction(state: PlayerConfigurationDefinitionState): PlayerConfigurationDefinitionState {
  const newState = _.clone(state);
  newState.array = [];
  return newState;
}
function handleClearAction(state: PlayerConfigurationDefinitionState): PlayerConfigurationDefinitionState {
  const newState = _.clone(state);
  newState.array = [];
  return newState;
}

function handleIsUsedAction(state: PlayerConfigurationDefinitionState, action: IsUsedPlayerConfigurationDefinitionAction): PlayerConfigurationDefinitionState {
  const newState = _.clone(state);
  newState.array  =  state.array.map(def => {
      if (def.name === action.payload.name) {
        const resp2 = { ...def, ...{isUsed: action.payload.value}};
        return resp2;
      }
      return def;
  });
  return newState;
}

export const playerConfigurationDefinitionSelectors = {
  array: (state: PlayerConfigurationDefinitionState) => _.get(state, 'array', [])
};
